import type { API } from 'chessboard/api/config/types';
import type { Move } from 'chessboard/model/move/types';
import { tryMovingForward } from 'chessboard/api/model/try-moving-forward';

/**
 * Create the canMoveForward function.
 */
export function createCanMoveForward(context: API.Context) {
  /**
   * Can move forward.
   */
  return function canMoveForward(params?: Move.Forward): boolean {
    const { move, followContinuations, steps } = params ?? {};

    const { success } = tryMovingForward({ context, move, followContinuations, steps });

    return success;
  };
}
